/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
    const root = document.querySelector(".countdown");
    if (!root) return;

    const targetStr = root.getAttribute("data-target");
    const target = new Date(targetStr);

    const $days = root.querySelector("[data-days]");
    const $hours = root.querySelector("[data-hours]");
    const $minutes = root.querySelector("[data-minutes]");
    const $seconds = root.querySelector("[data-seconds]");

    const pad2 = (n) => String(n).padStart(2, "0");

    function render() {
      const now = new Date();
      let diff = target - now;

      if (diff <= 0) {
        // fertig
        $days.textContent = "00";
        $hours.textContent = "00";
        $minutes.textContent = "00";
        $seconds.textContent = "00";
        root.classList.add("is-done");
        clearInterval(timer);
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      $days.textContent = String(days);       
      $hours.textContent = pad2(hours);
      $minutes.textContent = pad2(minutes);
      $seconds.textContent = pad2(seconds);
    }

    render();
    const timer = setInterval(render, 1000);
  })();

(function() {
  var startTime = new Date() >= new Date('2026-04-30T12:04:00+02:00')
  var endTime   = new Date('2026-05-03T23:59:59+02:00');

  function checkSaleBar() {
    var now = new Date();
    var bar = document.querySelector('.sale_bar');
    if (!bar) return;
    bar.style.display = (now >= startTime && now <= endTime) ? 'block' : 'none';
  }

  checkSaleBar();
  setInterval(checkSaleBar, 30000);
})();